<template>
  <div class="drawer_box" v-show="isShow">
    <el-drawer
      v-if="isShow"
      size="800px"
      :visible.sync="draw"
      :direction="direction"
      :modal-append-to-body="false"
      @close="closeFn"
    >
      <template slot="title">
        <div class="title_box">
          <img
            class="icon"
            src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/aiMessage/ai_title_icon.png"
            alt=""
          />
          <span class="title"><span>AI智能文案写作</span></span>
          <div class="ai_box_header_right" @click="changeAi">
            <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/copywriting.png" alt="" />
            <span>AI智能客服小云</span>
          </div>
        </div>
      </template>
      <div class="container">
        <div class="top">
          <el-form
            ref="form"
            :model="form"
            :label-width="form.buildType == 1 ? '94px' : '108px'"
          >
            <el-form-item label="写作类型：" required>
              <el-radio-group v-model="form.buildType">
                <el-radio :label="1">根据条件生成</el-radio>
                <el-radio :label="2" v-permission="'hide:ai:sms:content:custom'"
                  >自定义输入</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <template v-if="form.buildType == 1">
              <el-form-item label="活动名称：" required>
                <el-input
                  class="input_width"
                  v-model="form.activityName"
                  placeholder="请输入营销活动主题，例如618大促、双十一名称"
                  maxlength="32"
                ></el-input>
              </el-form-item>
              <el-form-item label="利益点：" required>
                <el-input
                  class="input_width"
                  type="textarea"
                  v-model="form.point"
                  placeholder="请输入活动利益点或优惠内容等"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  maxlength="150"
                ></el-input>
              </el-form-item>
              <el-form-item label="字数限制：" required>
                <el-input
                  class="input_width"
                  @input="form.wordLimit = getNumberData(1, $event, 1, 1)"
                  v-model="form.wordLimit"
                  placeholder="请输入字数限制"
                ></el-input>
              </el-form-item>
              <el-form-item label="活动链接：">
                <el-radio-group v-model="form.containLink">
                  <el-radio :label="1">包含短链接</el-radio>
                  <el-radio :label="0">不含短链接</el-radio>
                </el-radio-group>
              </el-form-item>
              <div class="tips_box">
                <img
                  class="icon"
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/aiMessage/tips_icon.png"
                  alt=""
                />
                <span class="tips_content"
                  >为防止超过字数上限，选择包含短链接时，插入短网址的原始链接域名为item.m.jd.com、shop.m.jd.com、shopmember.m.jd.com、coupon.m.jd.com时，转换后短链及前后空格占17字，点击可直接唤醒app。其它域名转换后的短链及前后空格占15字，且不可直接唤醒app</span
                >
              </div>
            </template>
            <template v-else>
              <el-form-item label="自定义内容：" required>
                <el-input
                  class="input_width"
                  style="width: 500px"
                  type="textarea"
                  v-model="form.content"
                  :placeholder="'您可以这样提问：\n\n请帮我生成1条营销短信文案，要求字数限制在70字以内。文案中涉及的营销活动为618，利益点为满20减10，活动链接为xxx。\n\n越清晰详细的指令描述，得到的结果越接近您想要的答案。'"
                  :autosize="{ minRows: 7, maxRows: 7 }"
                  maxlength="350"
                ></el-input>
              </el-form-item>
            </template>
          </el-form>
          <div class="operate_box">
            <div
              @click="createAI(0)"
              class="btn"
              :class="{ btn_forbidden: isRequest }"
            >
              生成内容
            </div>
            <div class="tips">
              每天限使用20次，今日还剩余<span class="num">{{ AITimes }}</span
              >次(重新生成也消耗次数)
            </div>
          </div>
          <div class="chat_window" id="chat_window">
            <div
              class="item"
              :class="item.type == 2 ? 'left' : 'right'"
              v-for="(item, index) in chatList"
              :key="index"
            >
              <img
                v-if="item.type == 2"
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/aiMessage/ai_left_icon.png"
                alt=""
              />
              <div class="message" :class="item.type == 2 ? 'AI' : 'monkey'">
                <span>{{ item.showText }}</span>
                <div class="message_handle" v-if="item.type == 2">
                  <div
                    class="handle_box"
                    @click="addFn(item.showText)"
                    v-if="type"
                  >
                    <img
                      class="message_icon"
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/aiMessage/add_icon.png"
                      alt=""
                    />
                    <span>添加到短信输入框</span>
                  </div>
                  <div
                    class="handle_box"
                    v-else
                    v-clipboard:copy="item.showText"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                  >
                    <img
                      class="message_icon"
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/aiMessage/copy_icon.png"
                      alt=""
                    />
                    <span>复制</span>
                  </div>
                  <div
                    class="handle_box"
                    :class="{ forbidden: isRequest }"
                    @click="createAI(1, item.id)"
                    v-if="index + 1 == chatList.length && isNeedAgain"
                  >
                    <img
                      class="message_icon"
                      :class="isRefresh ? 'refresh' : ''"
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/aiMessage/refresh_icon.png"
                      alt=""
                    />
                    <span>重新生成</span>
                  </div>
                </div>
              </div>
              <img
                v-if="item.type == 1"
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/aiMessage/ai_right_icon.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <!-- <div class="close_btn" @click="closeFn">关闭</div> -->
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { AIList, monkey, AI, AIAgain } from "@/api/AI";

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Number, // 0: 顶部 1: 短信操作
      default: 0,
    },
  },

  data() {
    return {
      direction: "rtl",
      draw: true,
      form: {
        buildType: 1,
        activityName: "",
        point: "",
        wordLimit: "",
        containLink: 1,
        content: "",
      },
      chatList: [], // 对话内容
      isCreating: false, // 是否创建
      isRefresh: false, // 是否刷新
      AITimes: 20, // 剩余次数
      isNeedAgain: false, // 是否需要重新生成按钮
      timer: null,
      timerNum: 0, // 用于计算10秒内AI应答是否成功
    };
  },

  computed: {
    isRequest() {
      return this.isCreating || this.isRefresh;
    },
  },

  watch: {
    isShow(newVal) {
      if (newVal) {
        this.draw = true;
        this.AIListFn();
      } else {
        this.draw = false;
      }
    },
  },

  mounted() {},

  methods: {
    changeAi() {
      this.$emit("change-types", 2);
    },
    AIListFn() {
      AIList().then((res) => {
        this.AITimes = 20 - Number(res.data.cnt || 0);
        this.chatList = res.data.record || [];
        this.scrollWindow();
      });
    },

    // 生成AI内容
    createAI(type, id) {
      // 0: 生成新内容，1：重新生成内容
      // 次数判断
      if (!this.AITimes) {
        return this.$message.warning("今日次数已用完！");
      }

      // 检验必填项
      if (this.form.buildType == 1) {
        // 条件生成
        if (!this.form.activityName) {
          return this.$message.error("活动名称不能为空！");
        }
        if (!this.form.point) {
          return this.$message.error("利益点不能为空！");
        }
        if (!this.form.wordLimit) {
          return this.$message.error("字数限制不能为空！");
        }
      } else {
        if (!this.form.content) {
          return this.$message.error("自定义内容不能为空！");
        }
      }

      // 节流
      if (this.isCreating || this.isRefresh) {
        return;
      }

      if (!type) {
        // 创建新的AI内容，右侧monkey需要增加一条消息记录
        this.isCreating = true;
        monkey(this.form).then((res) => {
          // 先生成一条monkey记录，再根据monkey的id请求生成AI应答记录
          if (res.code == 1) {
            this.chatList.push(res.data);
            this.chatList.push({ showText: "正在思考...", type: 2 }); // 如果是创建新的AI内容，需要存入一条新的AI内容 stringA，后续做逐字打印效果
            this.scrollWindow();
            this.AIFn(res.data.id);
            this.timer = setInterval(() => {
              this.timerNum++;
            }, 1000);
          } else {
            this.isCreating = false;
            this.isRefresh = false;
            this.$message.error(res.message);
          }
        });
      } else {
        // 重新生成AI内容
        if (!id) {
          // 超时未应答，最后一项非聊天列表内容，手动生成新的AI应答
          this.createAI(0);
          return;
        }
        this.isRefresh = true;
        AIAgain(id).then((res) => {
          // 重新生成一条monkey记录，再根据monkey的id请求生成AI应答记录
          if (res.code == 1) {
            this.chatList.push(res.data);
            this.chatList.push({ showText: "正在思考...", type: 2 }); // 如果是创建新的AI内容，需要存入一条新的AI内容 stringA，后续做逐字打印效果
            this.scrollWindow();
            this.AIFn(res.data.id);
            this.timer = setInterval(() => {
              this.timerNum++;
            }, 1000);
          } else {
            this.isCreating = false;
            this.isRefresh = false;
            this.$message.error(res.message);
          }
        });
      }
    },

    AIFn(id) {
      // 10秒内无应答不再循环
      if (this.timerNum == 10) {
        clearInterval(this.timer);
        this.timerNum = 0;
        this.isCreating = false;
        this.isRefresh = false;
        this.chatList[this.chatList.length - 1] = {
          showText: "这个接口暂时有点忙，请稍后再试哦~",
          type: 2,
        };
        return;
      }

      // stringA stringB用于做逐字打印效果
      let stringA = { showText: "", type: 2 }; // 逐字存入聊天窗口的内容
      let stringB = { showText: "", type: 2 }; // 完整AI消息内容
      AI(id).then((res) => {
        if (res.code == 1) {
          if (res.data) {
            clearInterval(this.timer);
            this.timerNum = 0; // 成功应答后，10秒计时重置
            this.isNeedAgain = true;
            this.AITimes--; // AI应答成功后手动将次数减一
            stringB = res.data;
            stringA.id = res.data.id;
            AIPrintFn();
            // 逐字打印完之后在放开按钮操作
            setTimeout(() => {
              this.isCreating = false;
              this.isRefresh = false;
            }, stringB.showText.length * 30);
          } else {
            this.AIFn(id);
          }
        } else {
          this.isCreating = false;
          this.isRefresh = false;
          this.$message.error(res.message);
        }
      });

      // 逐字打印效果
      const AIPrintFn = () => {
        this.chatList[this.chatList.length - 1] = stringA;
        this.$forceUpdate();
        this.scrollWindow();
        if (stringA.showText.length >= stringB.showText.length) {
          // 退出递归
          return;
        } else {
          // stringA仍然比stringB短，进入下一次等待和递归
          setTimeout(() => {
            stringA.showText += stringB.showText.charAt(
              stringA.showText.length
            );
            this.scrollWindow();
            AIPrintFn(stringA, stringB);
          }, 30);
        }
      };
    },

    // 添加到短信输入框
    addFn(item) {
      if (item.indexOf("#自定义短链接#") != -1) {
        this.$message.error(
          "短信文案中包含#自定义短链接#，请使用辅助工具插入短网址！"
        );
      }
      this.closeFn();
      this.$emit("add", item);
    },

    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },

    closeFn() {
      this.$emit("update:isShow", !this.isShow);
    },

    // 滚动AI聊天窗口
    scrollWindow() {
      const objDiv = document.getElementById("chat_window");
      setTimeout(() => {
        objDiv.scrollTop = objDiv.scrollHeight;
      }, 10);
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer_box {
  div {
    font-family: PingFangSC-Regular;
  }

  .title_box {
    display: flex;
    align-items: center;
    height: 30px;

    .icon {
      width: 30px;
      height: 30px;
      margin-right: 8px;
    }

    .title {
      font-size: 18px;
      transform: translateY(1px);

      span {
        background: linear-gradient(to right, #9a56f1 0%, #4c74fd 100%);
        -webkit-background-clip: text; /*将设置的背景颜色限制在文字中*/
        -webkit-text-fill-color: transparent; /*给文字设置成透明*/
        line-height: 1;
        font-weight: bold;
      }
    }
  }

  .container {
    position: relative;
    padding: 12px 0 16px 24px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .top {
      flex: 1;
      overflow: auto;
      margin-bottom: 20px;
    }

    .input_width {
      width: 360px;
      font-size: 14px;
    }

    .tips_box {
      width: 630px;
      // height: 28px;
      background: #fffaee;
      border-radius: 4px;
      display: inline-flex;
      align-items: center;
      vertical-align: middle;
      margin-left: 16px;
      font-size: 13px;
      padding: 10px;
      margin-left: 0;
      margin-bottom: 10px;
      margin-top: -18px;

      .icon {
        width: 38px;
        height: 15px;
        margin: 0 4px 0 8px;
      }

      .tips_content {
        font-size: 13px;
        color: #333333;
        line-height: 20px;
        white-space: break-spaces;
      }
    }

    .operate_box {
      display: flex;
      align-items: center;

      .btn {
        width: 80px;
        height: 32px;
        background: linear-gradient(90deg, #8f40f6 0%, #4e74fa 100%);
        border-radius: 4px;
        color: #ffffff;
        font-size: 14px;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
      }

      .btn_forbidden {
        cursor: not-allowed;
      }

      .tips {
        color: #666666;
        font-size: 14px;
        margin-left: 12px;

        .num {
          color: #7f85e9;
        }
      }
    }

    .chat_window {
      width: 752px;
      height: 446px;
      overflow: auto;
      background: linear-gradient(135deg, #e7f4ff 0%, #d7e0ff 100%);
      border-radius: 8px;
      padding: 30px 16px;
      margin-top: 20px;

      .item {
        margin-bottom: 20px;
        display: flex;
        align-items: center;

        &:last-child {
          margin-bottom: 20px;
        }

        img {
          width: 40px;
          height: 40px;
        }

        .message {
          position: relative;
          max-width: 500px;
          padding: 10px 20px;
          line-height: 20px;
          font-size: 14px;
          word-break: break-all;

          span {
            white-space: pre-wrap;
          }

          .message_handle {
            position: absolute;
            left: 0;
            bottom: -24px;
            width: 100%;
            color: #7278de;
            font-size: 12px;
            display: flex;
            white-space: pre;

            .handle_box {
              display: flex;
              align-items: center;
              cursor: pointer;
              margin-right: 16px;

              .message_icon {
                width: 12px;
                height: 12px;
                margin-right: 2px;
              }

              span {
                display: inline-block;
                white-space: pre;
              }

              .refresh {
                animation: rotate 0.5s linear infinite;
              }

              @keyframes rotate {
                from {
                  transform: rotate(0deg);
                }
                to {
                  transform: rotate(360deg);
                }
              }
            }

            .forbidden {
              cursor: not-allowed;
            }
          }
        }

        .AI {
          background: #ffffff;
          box-shadow: 0px 4px 16px 0px #e1e9fc;
          border-radius: 20px 20px 20px 0px;
          color: #333333;
          margin-left: 12px;
        }

        .monkey {
          background: #7f85e9;
          box-shadow: 0px 4px 16px 0px rgba(127, 133, 233, 0.5);
          border-radius: 20px 20px 0px 20px;
          color: #ffffff;
          margin-right: 12px;
        }
      }

      .left {
        justify-content: start;
        margin-bottom: 42px;
      }

      .right {
        justify-content: end;
      }
    }

    .close_btn {
      width: 80px;
      height: 32px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #cccccc;
      text-align: center;
      line-height: 32px;
      font-size: 14px;
      color: #666666;
      cursor: pointer;

      &:hover {
        border-color: #7f85e9;
        background: rgba(127, 133, 233, 0.2);
        color: #7f85e9;
      }
    }
  }

  div::-webkit-scrollbar-thumb {
    background: #c0c7dd;
    border-radius: 8px;
    width: 1px;
  }

  div::-webkit-scrollbar {
    width: 4px;
  }

  /deep/.el-drawer__header {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    color: #72767b;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 14px 14px 14px 24px;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 0;
  }

  /deep/.el-radio__label {
    color: #333333 !important;
  }

  /deep/.el-radio__inner:hover {
    border-color: #7f85e9;
  }

  /deep/.el-radio__inner::after {
    width: 8px !important;
    height: 8px !important;
    border-radius: 100%;
    background-color: #ffffff;
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    // -webkit-transform: translate(-50%, -50%) scale(0);
    // transform: translate(-50%, -50%) scale(0);
    -webkit-transition: -webkit-transform 0.15s ease-in;
    transition: -webkit-transform 0.15s ease-in;
    transition: transform 0.15s ease-in;
    transition: transform 0.15s ease-in, -webkit-transform 0.15s ease-in;
  }

  /deep/.el-radio__input.is-checked .el-radio__inner {
    border-color: #7f85e9;
    background: #7f85e9;
  }

  /deep/.el-textarea__inner {
    border: 1px solid #dcdfe6 !important;
    padding: 5px 8px !important;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;

    &:focus {
      border: 1px solid #7f85e9 !important;
    }
  }
  .ai_box_header_right {
   padding: 5px 8px;
    box-sizing: border-box;
    background: #E6EAFF;
    border-radius: 4px 4px 4px 4px;
    display: flex;
    align-items: center;
    margin-left: 20px;
    cursor: pointer;
    img {
      width: 18px;
      display: block;
      height: 18px;
      margin-right: 4px;
    }
    span {
      font-weight: bold;
      font-size: 12px;
      // color: #5272fc;
      // 设置颜色为渐变色linear-gradient(0deg, #9A56F1 0%, #4C74FD 100%);
      background: linear-gradient(0deg, #9A56F1 0%, #4C74FD 100%);
      -webkit-background-clip: text; /*将设置的背景颜色限制在文字中*/
      -webkit-text-fill-color: transparent; /*给文字设置成透明*/
    }
  }

  // /deep/.el-input__inner:focus {
  //   border: 1px solid #7F85E9 !important;
  // }
}
</style>
